<app-navbar [navList]="navList"></app-navbar>
<div class="qai-content-box overflow-auto">

  <!-- Info Utente -->
  <div class="card mb-4 shadow-sm border-0">
    <div class="card-header bg-primary text-white">Informazioni Utente</div>
    <div class="card-body">
      <p><strong>Nome:</strong> {{ licenseDetails().userinfo.name }} {{ licenseDetails().userinfo.surname }}</p>
      <p><strong>Email:</strong> {{ licenseDetails().userinfo.email }}</p>
      <p><strong>Telefono:</strong> {{ licenseDetails().userinfo.telephone }}</p>
    </div>
  </div>

  <!-- Info Cliente -->
  <div class="card mb-4 shadow-sm border-0">
    <div class="card-header bg-primary text-white">Dati Cliente</div>
    <div class="card-body">
      <p><strong>Ragione Sociale:</strong> {{ licenseDetails().delivery.customer.companyName }}</p>
      <p><strong>Partita IVA:</strong> {{ licenseDetails().delivery.customer.vatNumber }}</p>
      <p><strong>Telefono:</strong> {{ licenseDetails().delivery.customer.customerPhone }}</p>
      <p><strong>Email Supporto Commerciale:</strong> {{ licenseDetails().delivery.customer.commercialSupportEmail }}
      </p>
      <p><strong>Email Supporto Tecnico:</strong> {{ licenseDetails().delivery.customer.technicalSupportEmail }}</p>
    </div>
  </div>

  <!-- Licenza -->
  <div class="card mb-4 shadow-sm border-0">
    <div class="card-header bg-primary text-white">Licenza</div>
    <div class="card-body">
      <p><strong>Tipo:</strong> {{ licenseDetails().delivery.license.size.type }}</p>
      <p><strong>Richieste:</strong> {{ licenseDetails().delivery.license.size.request | number }} al mese</p>
      <p><strong>Storage:</strong> {{ licenseDetails().delivery.license.size.storage }} GB</p>
      <p><strong>Data Inizio:</strong> {{ licenseDetails().delivery.license.startDate | date:'dd/MM/yyyy' }}</p>
      <p><strong>Stato Licenza:</strong> <span class="badge ms-2"
          [ngClass]="getLicenseStatusColor(licenseDetails().delivery.license.status.type)">{{
          getLicenseStatus(licenseDetails().delivery.license.status.type) }}</span>
    </div>
  </div>

  @let apiKeyStatusEnabled = apiKeyStatus().enabled;

  <div class="card mb-4 shadow-sm border-0">
    <div class="card-header bg-primary text-white" [class.bg-secondary]="!apiKeyStatusEnabled">Integrazione API</div>
    <div class="card-body">
      <p>
        <strong>Stato Integrazione API:</strong> <span class="badge ms-2"
          [ngClass]="apiKeyStatusEnabled ? 'bg-success' : 'bg-danger'">{{ apiKeyStatusEnabled ? 'Abilitata' :
          'Disabilitata' }}
        </span>
      </p>
      <!-- API KEY -->
      <p>
        <strong>API Key:</strong>
        <code [class.text-muted]="!apiKeyStatusEnabled">
          {{ showApiKey ? licenseDetails().monitoring.tenant.apiKey : maskKey(licenseDetails().monitoring.tenant.apiKey) }}
        </code>
        <button type="button" class="btn btn-sm btn-secondary rounded-pill px-1 py-0" (click)="showApiKey = !showApiKey"
          type="button">
          <fa-icon [icon]="showApiKey ? faEyeSlash : faEye"></fa-icon>
        </button>
        <button class="btn btn-sm btn-secondary ms-1 rounded-pill px-1 py-0"
          (click)="copyKey(licenseDetails().monitoring.tenant.apiKey)">
          <fa-icon [icon]="faClipboard"></fa-icon>
        </button>
      </p>
      <!-- CLIENT ID -->
      <p>
        <strong>Client ID:</strong>
        <code [class.text-muted]="!apiKeyStatusEnabled">
          {{ showClientID ? licenseDetails().delivery.project.clientId : maskKey(licenseDetails().delivery.project.clientId) }}
        </code>
        <button type="button" class="btn btn-sm btn-secondary rounded-pill px-1 py-0"
          (click)="showClientID = !showClientID" type="button">
          <fa-icon [icon]="showClientID ? faEyeSlash : faEye"></fa-icon>
        </button>
        <button class="btn btn-sm btn-secondary ms-1 rounded-pill px-1 py-0"
          (click)="copyKey(licenseDetails().delivery.project.clientId)">
          <fa-icon [icon]="faClipboard"></fa-icon>
        </button>
      </p>
      <!-- RECAPTCHA SITE KEY ID -->
      <p>
        <strong>Recaptcha Site Key ID:</strong>
        <code [class.text-muted]="!apiKeyStatusEnabled">
          {{ showRecaptchaKey ? licenseDetails().delivery.project.recaptchaSitekeyId : maskKey(licenseDetails().delivery.project.recaptchaSitekeyId) }}
        </code>
        <button type="button" class="btn btn-sm btn-secondary rounded-pill px-1 py-0"
          (click)="showRecaptchaKey = !showRecaptchaKey" type="button">
          <fa-icon [icon]="showRecaptchaKey ? faEyeSlash : faEye"></fa-icon>
        </button>
        <button class="btn btn-sm btn-secondary ms-1 rounded-pill px-1 py-0"
          (click)="copyKey(licenseDetails().delivery.project.recaptchaSitekeyId)">
          <fa-icon [icon]="faClipboard"></fa-icon>
        </button>
      </p>
    </div>
  </div>

  @if(apiKeyStatusEnabled === false) {
  <app-loading-button [loading]="loading()" [disabled]="loading()" (click)="toggleApiKeyEnabled()" i18n>
    Abilita Integrazione API
  </app-loading-button>
  }
  @else {
  <app-loading-button buttonType="danger" [loading]="loading()" [disabled]="loading()" (click)="toggleApiKeyEnabled()" i18n>
    Disabilita Integrazione API
  </app-loading-button>
  }

</div>